import Layout from '@/layout';
var newUserRouter = {
  path: '/user',
  component: Layout,
  redirect: '/user/permission-setting',
  name: 'user',
  alwaysShow: true,
  meta: {
    title: '用户管理',
    icon: 'clipboard'
  },
  children: [
  // {
  //     path: 'permission-setting',
  //     component: () => import('@/views/my-create/permission-setting/index'),
  //     name: 'permission-setting',
  //     meta: { title: '权限设置', icon: '' }
  // },
  {
    path: 'shopping-car',
    component: function component() {
      return import('@/views/my-create/shopping-car/index');
    },
    meta: {
      title: '用户购物车',
      icon: ''
    }
  }, {
    path: 'user-list',
    component: function component() {
      return import('@/views/my-create/user-list/index');
    },
    name: 'user-list',
    meta: {
      title: '活跃用户',
      icon: ''
    }
  }]
};
export default newUserRouter;